import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type CategoriesStateType = Readonly<{
    isLoading: boolean;
    value: any;
}>;

const initialCounterState: CategoriesStateType = {
    isLoading: false,
    value: undefined,
};

const categoriesReducer = createTypedReducerWithImmer(initialCounterState, {
    "Custom/SiteMap/BeginLoadCategoryDataModel": (draft: Draft<CategoriesStateType>) => {
        draft.isLoading = true;
    },
    "Custom/SiteMap/CompleteLoadCategoryDataModel": (draft: Draft<CategoriesStateType>, action: { result: any }) => {
        draft.value = action.result;
        draft.isLoading = false;
    },
});

(reducers as any).categoriesReducer = categoriesReducer;

export type CategoriesState = {
    categoriesReducer: CategoriesStateType;
} & ApplicationState;

type Reducers = {
    categoriesReducer: typeof categoriesReducer;
};

export type CategoriesActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
